import { render } from "./Now.vue?vue&type=template&id=3ff66b2a&scoped=true&lang=pug"
import script from "./Now.vue?vue&type=script&lang=js"
export * from "./Now.vue?vue&type=script&lang=js"

import "./Now.vue?vue&type=style&index=0&id=3ff66b2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff66b2a"]])

export default __exports__